var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.28 155.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d7006c;}.cls-2{fill:#814d0c;}.cls-3{fill:#fff;}.cls-4{fill:none;stroke:#ba458c;stroke-miterlimit:10;}.cls-5{fill:#161615;}.cls-6{fill:#cc5292;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    className: "cls-1",
    d: "M77.81,155.62h-28c-61.31,0-53.72-94.15-41.11-133.7A49.92,49.92,0,0,1,49.81,0h28a49.34,49.34,0,0,1,31.51,11.37,50.31,50.31,0,0,1,4.09,3.77c13.06,13.48,14.08,34.38,14.52,52.06.51,20.31,1.65,41.94-7.11,60.85-5.85,12.62-15.16,22-33,26.55a49.11,49.11,0,0,1-10,1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    className: "cls-2",
    d: "M28.7,10.21a65.33,65.33,0,0,1,7-3.32c25.53-10.34,51.25-2,65.58,4.42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    className: "cls-3",
    d: "M63.53,37.9A28.19,28.19,0,1,1,35.34,9.72,28.18,28.18,0,0,1,63.53,37.9h0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    className: "cls-4",
    d: "M63.53,37.9A28.19,28.19,0,1,1,35.34,9.72,28.18,28.18,0,0,1,63.53,37.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    className: "cls-5",
    d: "M53.35,37.27A19.47,19.47,0,1,1,33.88,17.8,19.46,19.46,0,0,1,53.35,37.27h0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    className: "cls-3",
    d: "M36.66,27.42a9.24,9.24,0,1,1-9.24-9.24,9.24,9.24,0,0,1,9.24,9.24h0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    className: "cls-6",
    d: "M12.46,65.69c.87-1,10.4,5.36,25.71,5.07,7.45-.15,12.3-1.79,12.85-.9.71,1.14-6.06,5.86-14.1,6.55-13.56,1.17-25.5-9.59-24.46-10.73"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    className: "cls-3",
    d: "M120.11,37.9A28.18,28.18,0,1,1,91.93,9.72,28.17,28.17,0,0,1,120.11,37.9h0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    className: "cls-4",
    d: "M120.11,37.9A28.18,28.18,0,1,1,91.93,9.72,28.17,28.17,0,0,1,120.11,37.9Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    className: "cls-5",
    d: "M109.94,37.27A19.47,19.47,0,1,1,90.47,17.8a19.47,19.47,0,0,1,19.47,19.47h0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    className: "cls-3",
    d: "M90.65,27.42a9.24,9.24,0,1,1-9.24-9.24,9.24,9.24,0,0,1,9.24,9.24h0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    className: "cls-6",
    d: "M114.46,65.69c-.88-1-10.4,5.36-25.71,5.07-7.46-.15-12.3-1.79-12.86-.9C75.18,71,82,75.72,90,76.41c13.57,1.17,25.51-9.59,24.47-10.73"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/Icon4.d0f137cc659b23592b3bf575b36882a9.svg";
export { ForwardRef as ReactComponent };